import { useEffect } from "react";
import AdminPanelContainer from "../components/AdminPanelContainer";
import Sidebar from "../components/Sidebar";
import { getAllCategories } from "../constants/urls";
import { useRecoilState } from "recoil";
import { categoriesState } from "../state/category/Categories";
import useApi from "../services/ApiService";

export default function Dashboard() {
  const [categories, setCategories] = useRecoilState(categoriesState);
  const api = useApi();

  const loadCategories = async () => {
    let categories = await api
      .get(getAllCategories)
      .catch((e) => console.log(e));

    setCategories(categories?.data?.message);
  };

  useEffect(() => {
    loadCategories();
  }, []);



  return (

    <>
      <div>
        <Sidebar />
        <AdminPanelContainer />
      </div>
    </>


  );
}
